function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.50584 13.4932C3.53967 13.5271 3.57985 13.5539 3.62408 13.5723C3.6683 13.5906 3.71571 13.6 3.76358 13.6C3.81146 13.6 3.85886 13.5906 3.90309 13.5723C3.94731 13.5539 3.98749 13.5271 4.02132 13.4932L8.49858 9.01633L12.9777 13.4932C13.046 13.5615 13.1387 13.5999 13.2354 13.5999C13.3321 13.5999 13.4248 13.5615 13.4931 13.4932C13.5615 13.4248 13.5999 13.3321 13.5999 13.2355C13.5999 13.1388 13.5615 13.0461 13.4931 12.9778L9.01407 8.50089L13.4913 4.02222C13.5597 3.95386 13.5981 3.86116 13.5981 3.7645C13.5981 3.66783 13.5597 3.57513 13.4913 3.50678C13.423 3.43842 13.3303 3.40002 13.2336 3.40002C13.1369 3.40002 13.0442 3.43842 12.9758 3.50678L8.49858 7.98545L4.0195 3.5086C3.94981 3.44892 3.86017 3.41774 3.76848 3.42128C3.67679 3.42482 3.58982 3.46282 3.52494 3.5277C3.46006 3.59257 3.42205 3.67954 3.41851 3.77121C3.41497 3.86289 3.44616 3.95253 3.50584 4.02222L7.98309 8.50089L3.50584 12.9796C3.43799 13.0478 3.3999 13.1401 3.3999 13.2364C3.3999 13.3326 3.43799 13.4249 3.50584 13.4932Z",
  fill: "#0D183F"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.f45d869a.svg";
export { ForwardRef as ReactComponent };